import { jsx } from "react/jsx-runtime";
import { FieldRichLabel } from "./field-rich-label.js";
const RICOS_THEME = {
  customStyles: {
    p: {
      fontSize: "var(--wix-forms-formInputValueFont-size, 16px)",
      fontFamily: "var(--wix-forms-formInputValueFont-family)",
      fontWeight: "var(--wix-forms-formInputValueFont-weight)",
      fontStyle: "var(--wix-forms-formInputValueFont-style)",
      textDecoration: "var(--wix-forms-formInputValueFont-text-decoration)",
      color: "rgb(var(--wix-forms-formInputOptionColor, 0,0,0))"
    }
  }
};
const FieldRichLabelWUT = (props) => /* @__PURE__ */ jsx(FieldRichLabel, { ricosTheme: RICOS_THEME, ...props });
export {
  FieldRichLabelWUT
};
//# sourceMappingURL=field-rich-label-wut.js.map
